/** 上传相关接口 */
import request from '@/utils/util.request';

/*
 *  (upload) 打开页面前，加载显示
 */
export const upload_load = (data) => {
	return request({
		url: '/upload/loaddata',
		data,
	});
};

/*
 *  (upload) 上传前获取参数
 *  @param {string} file: 文件名包括后缀
 *  @param {string} size: 文件大小(B)
 */
export const upload_pre = (data) => {
	return request({
		url: '/upload/preupload',
		data,
	});
};

/*
 *  (upload) 上传后提交结果
 *  @param {int} id: 上个请求的返回
 *  @param {int} file_id: 上个请求的返回
 *  @param {string} key: 上个请求的返回
 *  @param {string} mimeType: 文件的mimeType
 */
export const upload_done = (data) => {
	return request({
		url: '/upload/uploaddone',
		data,
		returnFull: true,
	});
};
